import {
  RESET_SESSION,
  LOGGED_USER_DETAILS,
  USER_EMAIL,
  USER_LOGOUT,
  USER_TOKEN,
  USER_SET_INSTITUTION,
  USER_SET_ACTIVE_CAS,
  USER_SET_INSTITUTION_LOADING,
} from '../../actionTypes/Users/UserActionType';

const getInitialUserDetails = () => ({
  email: '',
  token: null,
  institutionDetailsLoading: false,
  institutionDetails: {
    casOrgs: [],
    institutionClientId: null,
    institutionName: '',
  },
  activeCasDetails: {
    casId: '',
    name: '',
    clientId: '',
    clientName: '',
  },
  userDetails: {
    given_name: '',
    family_name: '',
    userRole: '',
    email: '',
    phone_number: '',
  },
});

export default function loggedUserDetailsReducer(state = { ...getInitialUserDetails() }, action) {
  switch (action.type) {
    case RESET_SESSION:
      return { ...state, ...getInitialUserDetails() };
    case LOGGED_USER_DETAILS:
      return { ...state, userDetails: { ...state.userDetails, ...action.payload } };
    case USER_EMAIL:
      return { ...state, email: action.email };
    case USER_TOKEN:
      return { ...state, token: action.token };
    case USER_LOGOUT:
      return { ...state, ...getInitialUserDetails() };
    case USER_SET_INSTITUTION_LOADING:
      return { ...state, institutionDetailsLoading: action.payload };
    case USER_SET_INSTITUTION:
      const { casOrgs = [] } = action.payload;
      const casItem = casOrgs.length > 0 ? casOrgs.slice().pop() : null;
      const casDetails = casItem
        ? {
            casId: casItem.casId,
            name: casItem.name,
            clientName: casItem.clients[0].name,
            clientId: casItem.clients[0].id,
          }
        : { };
      return { ...state, institutionDetails: action.payload, activeCasDetails: casDetails };
    case USER_SET_ACTIVE_CAS:
      return { ...state, activeCasDetails: action.payload };
    default:
      return state;
  }
}
